// src/components/widgets/CartWidget/CartWidget.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCart } from '../../../hooks/useCart.js';
import { Button } from '../../ui/Button/Button.jsx';
import { Modal } from '../../ui/Modal/Modal.jsx';
import { setCart } from '../../../store/uiSlice.js';
import { Link } from 'react-router-dom';

export const CartWidget = () => {
  const dispatch = useDispatch();
  const { items, total, count, removeFromCart, updateCartItem } = useCart();
  const isOpen = useSelector((state) => state.ui.isCartOpen);

  const handleClose = () => dispatch(setCart(false));

  const handleQuantityChange = (id, quantity) => {
    if (quantity < 1) return;
    updateCartItem(id, { quantity });
  };

  const handleRemove = (id) => {
    removeFromCart(id);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Корзина (${count} товаров)`}
      size="md"
    >
      {items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <p style={{ fontSize: '18px', color: 'rgb(var(--c-text-secondary))' }}>Корзина пуста</p>
          <Button onClick={handleClose} style={{ marginTop: '16px' }}>
            Продолжить покупки
          </Button>
        </div>
      ) : (
        <>
          <div style={{ maxHeight: '400px', overflow: 'auto' }}>
            {items.map((item) => (
              <div
                key={item.id}
                style={{
                  display: 'flex',
                  gap: '16px',
                  padding: '16px 0',
                  borderBottom: '1px solid rgb(var(--c-border))',
                  alignItems: 'center',
                }}
              >
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'rgb(var(--c-border))',
                  borderRadius: '8px',
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: 'rgb(var(--c-text-secondary))',
                }}>
                  {item.Product?.name?.slice(0, 2) || 'Товар'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500, color: 'rgb(var(--c-text))' }}>
                    {item.Product?.name || 'Товар'}
                  </div>
                  <div style={{ fontSize: '14px', color: 'rgb(var(--c-text-secondary))' }}>
                    {item.price_at_time} ₽
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <button
                    onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                    style={{
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      border: '1px solid rgb(var(--c-border))',
                      background: 'white',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    −
                  </button>
                  <span style={{ minWidth: '24px', textAlign: 'center' }}>
                    {item.quantity}
                  </span>
                  <button
                    onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                    style={{
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      border: '1px solid rgb(var(--c-border))',
                      background: 'white',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    +
                  </button>
                </div>
                <button
                  onClick={() => handleRemove(item.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'rgb(var(--c-text-secondary))',
                    cursor: 'pointer',
                    fontSize: '18px',
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>

          <div style={{
            borderTop: '2px solid rgb(var(--c-border))',
            paddingTop: '16px',
            marginTop: '16px',
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '18px',
              fontWeight: 600,
              color: 'rgb(var(--c-text))',
            }}>
              <span>Итого:</span>
              <span>{total} ₽</span>
            </div>
            <div style={{
              display: 'flex',
              gap: '12px',
              marginTop: '16px',
            }}>
              <Button
                variant="secondary"
                onClick={handleClose}
                style={{ flex: 1 }}
              >
                Продолжить
              </Button>
              <Link to="/checkout" style={{ flex: 1, textDecoration: 'none' }}>
                <Button
                  onClick={handleClose}
                  style={{ width: '100%' }}
                >
                  Оформить заказ
                </Button>
              </Link>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};